import { createFileRoute } from '@tanstack/react-router'
import { AccountingPage } from '@/features/accounting'

export const Route = createFileRoute('/_authenticated/deposits-company/')({
  component: () => (
    <AccountingPage
      kind='deposits'
      accountType='company'
      mode='operations'
      reviewPermission='deposit.company.review'
      pageKey='companyOps'
    />
  ),
})
